import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, Router, RouterLink, RouterLinkActive} from '@angular/router';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {NavbarComponent} from "../../navbar.component";
import {MenuService} from "../../../../services/menu.service";
import {NgClass, NgIf} from "@angular/common";
import {Ripple} from "primeng/ripple";
import {NgForOf} from "@angular/common";
import {BadgeModule} from "primeng/badge";

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  host: {
    '[class.active-menuitem]': 'active',
  },
  standalone: true,
  imports: [
    RouterLink,
    NgClass,
    RouterLinkActive,
    Ripple,
    NgIf,
    NgForOf,
    BadgeModule
  ],
  animations: [
    trigger('children', [
      state('void', style({
        height: '0px'
      })),
      state('hiddenAnimated', style({
        height: '0px'
      })),
      state('visibleAnimated', style({
        height: '*'
      })),
      transition('visibleAnimated => hiddenAnimated',
        animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
      transition('hiddenAnimated => visibleAnimated',
        animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
      transition('void => visibleAnimated, visibleAnimated => void',
        animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ]
})
export class MenuItemComponent implements OnInit, OnDestroy {

  @Input() item: any;

  @Input() index?: number;

  @Input() root?: boolean;

  @Input() parentKey?: string;

  active = false;

  menuSourceSubscription: Subscription;

  menuResetSubscription: Subscription;

  key?: string;

  constructor(
    public app: NavbarComponent,
    public router: Router,
    private cd: ChangeDetectorRef,
    private menuService: MenuService) {
    this.menuSourceSubscription = this.menuService.menuSource$.subscribe(key => {
      if (this.active && this.key && this.key !== key && key.indexOf(this.key) !== 0) {
        this.active = false;
      }
    });

    this.menuResetSubscription = this.menuService.resetSource$.subscribe(() => {
      this.active = false;
    });

    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(params => {
        if (this.item.routerLink) {
          this.updateActiveStateFromRoute();
        } else {
          this.active = false;
        }
      });
  }

  ngOnInit() {
    if (this.item.routerLink) {
      this.updateActiveStateFromRoute();
    }

    this.key = this.parentKey ? this.parentKey + '-' + this.index : String(this.index);
  }

  updateActiveStateFromRoute() {
    // item.routerLink in our menu model is a string (e.g. '/dashboard/service-city').
    // Use non-exact matching universally so base routes remain active on child routes as well.

    const link: string = this.item?.routerLink;
    this.active = this.router.isActive(link, false);
  }

  itemClick(event: Event) {
    event.stopPropagation();
    if (this.item.disabled) {
      event.preventDefault();
      return;
    }

    if (this.key) {
      this.menuService.onMenuStateChange(this.key);
    }

    if (this.item.command) {
      this.item.command({originalEvent: event, item: this.item});
    }

    if (this.item.items) {
      this.active = !this.active;
    } else {
      this.active = true;
      this.app.menuActiveMobile = false;

    }
  }

  ngOnDestroy() {
    if (this.menuSourceSubscription) {
      this.menuSourceSubscription.unsubscribe();
    }

    if (this.menuResetSubscription) {
      this.menuResetSubscription.unsubscribe();
    }
  }
}
